enum ModelType {
  Merchant = 'Merchant',
  Offer = 'Offer',
  Location = 'Location',
  MergedOffer = 'MergedOffer',
}

export default ModelType;
